import { http } from '@/core/helpers/http.helper';
import { CandidateEducation } from '../candidate.interface';
import { ApiResource } from '@/core/models/api-resource.interface';

export class EducationService {
   async patchEducation(candidateId: number, education: CandidateEducation) {
      const response = await http.patch<ApiResource<Array<CandidateEducation>>>(
         `/candidates/${candidateId}/educations/${education.id}`,
         education,
      );
      return response.data;
   }

   async postEducation(candidateId: number, education: CandidateEducation) {
      const response = await http.post<ApiResource<Array<CandidateEducation>>>(`/candidates/${candidateId}/educations`, education);
      return response.data;
   }

   async deleteEducation(candidateId: number, educationId: number) {
      const response = await http.delete<ApiResource<Array<CandidateEducation>>>(`/candidates/${candidateId}/educations/${educationId}`);
      return response.data;
   }
}
